import { FirstPay, getPaysApi, Pay, PayDataType } from "@/api/promo";
import { getToken } from "@/utils/Cookies";
import { create } from "zustand";

interface State {
    first_pay: FirstPay[];
    pay: Pay[];
}

interface Action {
    getPayData: () => Promise<PayDataType | undefined>;
    getFirstPayData: () => void;
}

const initState: State = {
    first_pay: [],
    pay: [],
};

export const useFirstPayStore = create<State & Action>()((set, get) => {
    return {
        ...initState,
        getPayData: async () => {
            if (getToken()) {
                return getPaysApi().then((res) => {
                    const first_pay = Array.isArray(res.data.first_pay) ? res.data.first_pay : [];
                    const pay = Array.isArray(res.data.pay) ? res.data.pay : [];
                    set((value) => ({ ...value, first_pay, pay }));
                    return res.data;
                });
            }
        },

        getFirstPayData: () => {
            get().getPayData();
        },
    };
});
